module.exports = __webpack_public_path__ + "static/media/share-btn.5048158a.svg";